import Vue from 'vue'
import 'babel-polyfill'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = () => {
  return {
    token: '',
    userInfo: {},
    aside: [],
    cacheData: {},
    roleInfo: {},
    opertorInfo: {},
    compile: {},
    taxpayer: {},
    declare: {},
    importDetail: {},
    approvalDetail: {},
    failData: [],
    otherPayDetail: {},
    invoiceInfo: {},
    random: null,
    forgetRandom: null,
    delayeringMune: [],
    platformInfo: {},
    taxMoney: {}
  }
}
const mutations = {
  SET_TOKEN (state, val) {
    state.token = val
  },
  SET_USERINFO (state, val) {
    state.userInfo = val
  },
  SET_ASIDE (state, val) {
    state.aside = val
  },
  SET_CACHEDATA (state, val) {
    state.cacheData = val
  },
  SET_ROLEINFO (state, val) {
    state.roleInfo = val
  },
  SET_OPERTORINFO (state, val) {
    state.opertorInfo = val
  },
  SET_COMPILE (state, val) {
    state.compile = val
  },
  SET_TAXPAYER (state, val) {
    state.taxpayer = val
  },
  SET_DECLARE (state, val) {
    state.declare = val
  },
  SET_TAXMONEY (state, val) {
    state.taxMoney = val
  },
  SET_IMPORTDETAIL (state, val) {
    state.importDetail = val
  },
  SET_APPROVALDETAIL (state, val) {
    state.approvalDetail = val
  },
  SET_FAILDATA (state, val) {
    state.failData = val
  },
  SET_OTHERPAYDETAIL (state, val) {
    state.otherPayDetail = val
  },
  SET_INVOICEINFO (state, val) {
    state.invoiceInfo = val
  },
  SET_RANDOM (state, val) {
    state.random = val
  },
  SET_FORGETRANDOM (state, val) {
    state.forgetRandom = val
  },
  SET_DELAYERINGMUNE (state, val) {
    state.delayeringMune = val
  },
  SET_PLANFORMINFO (state, val) {
    state.platformInfo = val
  }
}
const actions = {
  set_token ({ commit }, val) {
    commit('SET_TOKEN', val)
  },
  set_userInfo ({ commit }, val) {
    commit('SET_USERINFO', val)
  },
  set_aside ({ commit }, val) {
    commit('SET_ASIDE', val)
  },
  set_cachedata ({ commit }, val) {
    commit('SET_CACHEDATA', val)
  },
  set_roleInfo ({ commit }, val) {
    commit('SET_ROLEINFO', val)
  },
  set_opertorInfo ({ commit }, val) {
    commit('SET_OPERTORINFO', val)
  },
  set_compile ({ commit }, val) {
    commit('SET_COMPILE', val)
  },
  set_taxpayer ({ commit }, val) {
    commit('SET_TAXPAYER', val)
  },
  set_declare ({ commit }, val) {
    commit('SET_DECLARE', val)
  },
  set_taxMoney ({ commit }, val) {
    commit('SET_TAXMONEY', val)
  },
  set_importdetail ({ commit }, val) {
    commit('SET_IMPORTDETAIL', val)
  },
  set_approvaldetail ({ commit }, val) {
    commit('SET_APPROVALDETAIL', val)
  },
  set_failData ({ commit }, val) {
    commit('SET_FAILDATA', val)
  },
  set_otherPayExportDetail ({ commit }, val) {
    commit('SET_OTHERPAYDETAIL', val)
  },
  set_invoiceInfo ({ commit }, val) {
    commit('SET_INVOICEINFO', val)
  },
  set_random ({ commit }, val) {
    commit('SET_RANDOM', val)
  },
  set_forgetRandom ({ commit }, val) {
    commit('SET_FORGETRANDOM', val)
  },
  set_delayeringMune ({ commit }, val) {
    commit('SET_DELAYERINGMUNE', val)
  },
  set_platformInfo ({ commit }, val) {
    commit('SET_PLANFORMINFO', val)
  }
}

const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules,
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]

})



// WEBPACK FOOTER //
// ./src/store/store.js